//{{-- ========================================================================================== --}}
//{{-- Scripts for processing acbrcanew                                                           --}}
//{{-- ========================================================================================== --}}

var abcListFull = [];               //{{-- list of items that is shown in the select element --}}
var abcListOriginal = [];           //{{-- original list of items, to serve as baseline --}}
var abcChosen = [];                 //{{-- var to hold the last item inserted, a 'return' of sorts --}}
var abcParentId = -1;               //{{-- if item is campaign, holds the brand id, if brand, holds account id, if account, holds user id --}}
var abcType = null;                 //{{-- account, brand, campaign --}}

$(function(){
    //{{-- Handle list filtering as user types in input field --}}
    $('#abcInput').keyup(function(evt) {
        evt.stopImmediatePropagation();
        populateList(abcListFull, true, $('#abcInput').val().trim());
    });

    //{{-- Handle adding item to the list --}}
    $('#abcAdd').click(function(evt) {
        evt.stopImmediatePropagation();
        addAbc();
    });

    //{{-- Handle removing item from the list --}}
    $('#abcRemove').click(function(evt) {
        evt.stopImmediatePropagation();
        removeAbc();
    });

    //{{-- Handle selecting an item on the list --}}
    $('#slAbrcaList').change(function(evt) {
        evt.stopImmediatePropagation();
        $('#abcInput').val($('#slAbrcaList option:selected').text());
    });

    //{{-- Handle saving the list --}}
    $('#abcSave').click(function(evt) {
        evt.stopImmediatePropagation();
        if (!$('#abcSave').hasClass('disabled')) saveAbc();
    });

    //{{-- Handle cancelling - closes the modal --}}
    $('.abcModalCancel').click(function(evt) {
        evt.stopImmediatePropagation();
        $('#modalnewABC').modal('hide');
        $('#success-msg').attr("style","display:none");
        $('#abcSave').addClass('disabled');
        newABCModalCallback(abcType, 0);
    });

});

//{{-- This initializes the list field --}}
window.initModalnewABC = function(type, parentId) {
    //{{-- Store the parent id and type --}}
    abcParentId = parentId;
    abcType = type;
    //{{-- Insert the type in the places that need it: --}}
    entertxt   = (type == 'account') ? abc_enter_new_account : (type == 'brand' ? abc_enter_new_brand : abc_enter_new_campaign);
    $('#promptLine').html(entertxt);
    $('#abcInput').attr("placeholder", entertxt);
    //{{-- Load the list content --}}
    loadModalnewABC();
}

//{{-- Populate the select field with the content of abcListFull --}}
function populateList(abcListFull, filter, filterTxt) {
    //{{-- Prepare the select field --}}
    field = $('#slAbrcaList');
    field.empty();
    field.attr("size", "7");
    //{{-- Sort the list object --}}
    abcListFull.sort(function(a,b) {                                                            //{{-- the "=>" shorthand notation does not work in IE --}}
        a[1].toLowerCase() > b[1].toLowerCase() ? 1 : -1 ;                    
    });
    //{{-- Populate the select field--}}
    for (ndx in abcListFull) {
        value = abcListFull[ndx][0];
        text = abcListFull[ndx][1];
        if (!filter || text.toLowerCase().includes(filterTxt.toLowerCase())) {
            if (filterTxt && text.toLowerCase() == filterTxt.toLowerCase()) {
                field.append($("<option></option>").attr("value", value).attr("selected", "selected").text(text));
            } else {
                field.append($("<option></option>").attr("value", value).text(text));
            }                    
        }                
    };            
}

//{{-- Add an item to the list --}}
function addAbc() {
    //{{-- Check that item is not on list yet --}}
    abc = $('#abcInput').val().trim();
    if (abc != "") {
        ndx = abcListFullIndex(abc);
        if (ndx) {
            alert(abc + abc_is_already_on_list);
        } else {
            abcListFull.push([-1, abc]);                                                    //{{-- Insert item in List --}}
            populateList(abcListFull, false, abc);                                          //{{-- Reload list --}}
            $('#abcSave').removeClass('disabled');                                          //{{-- Activate the save button --}}
            $('#abcInput').focus();                                     
        }
    }
}

//{{-- Remove an item from the list --}}
function removeAbc() {
    //{{-- Check that item is  list --}}
    abc = $('#abcInput').val();
    ndx = abcListFullIndex(abc);
    if (!ndx) {
        alert(abc + abc_does_not_exist);
    } else {
        oldItem = $.grep(Object.keys(abcListOriginal), function (key, ndx) {                //{{-- No support for array.find in IE11 --}}
            return abcListOriginal[key][1] === abc;
        });
    
        if (oldItem.length > 0) {
            alert(abc_can_only_remove_new_items);
        } else {
            delete abcListFull[ndx];                                                        //{{-- Delete item from List --}}
            populateList(abcListFull, false, null);                                         //{{-- Reload list --}}
            if (isListContentEqual(abcListFull, abcListOriginal)) {
                $('#abcSave').addClass('disabled');                                         //{{-- Deactivate the save button --}}
            }
        }
        $('#abcInput').focus();
    }
}

//{{-- Checks whether a string exists in abcListFull, returns its index or null --}}
function abcListFullIndex(abc) {
    index = null;
    for (ndx in abcListFull) {
        text = abcListFull[ndx][1];
        if ( abc.toLowerCase() == text.toLowerCase()) {
            index = ndx;
            break;
        }
    }
    return index;
}

//{{-- Does a shallow comparison of two objects --}}
function isListContentEqual(a, b) {
    for(var key in a) {
        if(!(key in b) || a[key][0] !== b[key][0]  || a[key][1] !== b[key][1]) return false;
    }
    for(var key in b) {
        if(!(key in a) ||  a[key][0] !== b[key][0]  || a[key][1] !== b[key][1]) return false;
    }
    return true;
}

//{{-- Ajax call to load the list field --}}
function loadModalnewABC() {       
    //{{-- Get ABC description constants from database - ClientsController - This is an AJAX call, so it's asynch ! --}}
    field = $('#slAbrcaList');
    field.empty();
    field.attr("size", "7");
    abcListFull.length = 0;
    abcListOriginal.length = 0;
    $.get('/clients/abc/' + abcType + '/' + abcParentId + '/0', function(data){
        //{{-- Put data into list and make an original copy --}}
        $.each(data['descList'], function(key, value) {
            abcListFull.push([value, key]);
            abcListOriginal.push([value, key]);
        });
        //{{-- Sort lists--}}
        abcListFull.sort(function(a,b) {                                                            //{{-- the "=>" shorthand notation does not work in IE --}}
            a[1].toLowerCase() > b[1].toLowerCase() ? 1 : -1 ;      
        });
        abcListOriginal.sort(function(a,b) {                                                        //{{-- the "=>" shorthand notation does not work in IE --}}
            a[1].toLowerCase() > b[1].toLowerCase() ? 1 : -1 ;
        });
        //{{-- Poulate the select field --}}
        populateList(abcListFull, false, null);
    });
}

//{{-- Saves new items in abcListFull to the database, sets public var abcChosen --}}
//{{-- We are not doing deletes at this point, only saving new items --}}
function saveAbc() {
    //{{-- First, figure out exactly with items need to be saved --}}
    saveList = [];
    for(var key in abcListFull) {
        if (abcListFull[key][0] == -1) saveList.push(abcListFull[key][1]);
    }
    $.ajax({
        url: abc_route_saveabc,
        method: "POST",
        data: {
            type: abcType, 
            parentId : abcParentId, 
            saveList: saveList,
        },
        success:function(data) {
            //{{-- if successful, the callback receives data, textStatus, jqXHR object --}}
            //{{-- data.existed and data.saved are returned --}}
            savedKeys = Object.keys(data.saved);
            if (savedKeys.length > 0) {
                $('#success-msg').html(abc_new_items_saved + savedKeys.length);    //{{-- Prepare success message --}}
                lastSaved = Math.max.apply(null, savedKeys);                                //{{-- Get last item key saved --}}             
            } else {
                $('#success-msg').html(abc_no_new_items_saved);
                lastSaved = 0;
            }
            //{{-- Show success message --}}
            $('#success-msg').attr("style","display:group");
            //{{-- After a couple of seconds, call the modal callback function - this will close the modal --}}
            setTimeout(function(){ 
                $('#success-msg').attr("style","display:none");
                newABCModalCallback(abcType, lastSaved); 
                }, 1000);
        },
        error:function(jqXHR1, textStatus, jqXHR2) {                            
            //{{-- if failed, the callback function receives jqXHR object, textStatus, errorThrown --}}
            if (jqXHR1.status >= 550 && jqXHR1.status <= 559 ) {
                alert(abc_err_saving + "\n"
                        + abc_err_nbr + jqXHR1.status + "\n"
                        + abc_additional_info + jqXHR1.responseJSON.message 
                        );
                $('.abcModalCancel').click();
            }
        }               
    });
}